import palmLeafsLeft from 'assets/images/decors/promotions/marchPromo/palmLeafsLeft.svg'
import palmLeafsLeftSmall from 'assets/images/decors/promotions/marchPromo/palmLeafsLeftSmall.svg'
import palmLeafsRight from 'assets/images/decors/promotions/marchPromo/palmLeafsRight.svg'
import palmLeafsRightSmall from 'assets/images/decors/promotions/marchPromo/palmLeafsRightSmall.svg'
import ticketSeparator from 'assets/images/decors/promotions/marchPromo/ticketSeparator.svg'
import ticketSeparatorSmall from 'assets/images/decors/promotions/marchPromo/ticketSeparatorSmall.svg'
import { GuestsDataContext } from 'components/common/MarchPromo/utils/guestsDataProvider'
import { useGuestsCart } from 'components/common/MarchPromo/utils/useGuestsCart'
import Box from 'components/shared/Box'
import Button from 'components/shared/Button'
import Loader from 'components/shared/Loader'
import Text from 'components/shared/Text'
import { useContext, useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { useApp } from 'store/steps'
import { AddedVouchers } from './components/AddedVouchers/AddedVouchers'
import { VoucherForm } from './components/VoucherForm/VoucherForm'
import { MarchPromoContainer, MarchPromoInfoWrapper } from './styles'

const MarchPromoInfo = () => {
    const { language } = useApp()
    const { cartItems } = useGuestsCart()

    const {
        marchVouchersData,
        voucherPrice,
        isLoading,
        setTotalPrice,
        setVoucherPrice,
        setFormData,
        setIsLoading,
    } = useContext(GuestsDataContext)

    const [isSelectorOpen, setIsSelectorOpen] = useState(
        marchVouchersData.length !== 0
    )
    const [isEditMode, setIsEditMode] = useState(false)

    const isUkrainian = language === 'uk'

    useEffect(() => {
        if (marchVouchersData.length !== 0 && cartItems.length !== 0)
            setIsSelectorOpen(true)
        else setIsSelectorOpen(false)
    }, [marchVouchersData.length, cartItems.length])

    return (
        <MarchPromoContainer>
            <MarchPromoInfoWrapper isFullWidth direction={['column', 'row']}>
                <img
                    src={palmLeafsLeft}
                    alt="Decorative palm leaves on the left side"
                    className="palm-leafs-left large-icon"
                />
                <img
                    src={palmLeafsRight}
                    alt="Decorative palm leaves on the right side"
                    className="palm-leafs-right large-icon"
                />
                <img
                    src={palmLeafsLeftSmall}
                    alt="Small decorative palm leaves on the left side"
                    className="palm-leafs-left small-icon"
                />
                <img
                    src={palmLeafsRightSmall}
                    alt="Small decorative palm leaves on the right side"
                    className="palm-leafs-right small-icon"
                />
                <Box
                    gap={8}
                    width={['100%', isUkrainian ? '463px' : '440px']}
                    className="promo-info"
                    px={[24, 0]}
                    pt={[24, 0]}
                >
                    <Box
                        className="badge"
                        bgColor="blue_100"
                        borderColor="blue_200"
                        borderWidth={1}
                        borderRadius={4}
                        py={4}
                        px={8}
                    >
                        <Text variant="bodySmall" color="blue_600">
                            <FormattedMessage
                                id="promo.march.badge"
                                defaultMessage="Marcowa Promocja"
                            />
                        </Text>
                    </Box>
                    <Text variant="heading3" color="secondary_500">
                        <FormattedMessage
                            id="promo.march.banner_title"
                            defaultMessage="Kolejna wizyta już od 30 zł!"
                        />
                    </Text>
                    <Text variant="body" color="grayscale_800">
                        <FormattedMessage
                            id="promo.march.banner_description"
                            defaultMessage="Odwiedzasz nas w marcu? Zgarnij voucher na kolejną, taką samą wizytę w Suntago już od 30 zł za osobę!"
                        />
                    </Text>
                </Box>
                <img
                    src={ticketSeparatorSmall}
                    alt="Decorative banner separator"
                    className="ticket-separator"
                    width="100%"
                />
                {isLoading && <Loader />}
                {!isLoading && !isSelectorOpen && (
                    <Box
                        width={['100%', '240px']}
                        className="cta-box"
                        pb={[24, 0]}
                        px={[24, 0]}
                        pt={[10, 0]}
                    >
                        <Button
                            variant="secondary"
                            width="100%"
                            onClick={() => {
                                setIsSelectorOpen(true)
                                setIsEditMode(true)
                                setFormData(true)
                            }}
                        >
                            <FormattedMessage
                                id="promo.march.cta"
                                defaultMessage="Skorzystaj z promocji"
                            />
                        </Button>
                    </Box>
                )}
            </MarchPromoInfoWrapper>
            {isSelectorOpen && !isLoading && (
                <>
                    {(isEditMode || !!cartItems.length) && (
                        <img
                            src={ticketSeparator}
                            alt="Decorative banner separator"
                            className="ticket-separator-desktop"
                            width="100%"
                        />
                    )}
                    {(cartItems.length === 0 || isEditMode) && (
                        <VoucherForm
                            onCancel={() => {
                                if (cartItems.length) {
                                    setIsEditMode(false)
                                } else {
                                    setIsSelectorOpen(false)
                                    setTotalPrice(0)
                                    setVoucherPrice(0)
                                }
                            }}
                            onSuccess={() => {
                                setIsLoading(true)
                                setIsEditMode(false)
                            }}
                        />
                    )}
                    {cartItems.length !== 0 &&
                        !isEditMode &&
                        voucherPrice !== undefined && (
                            <AddedVouchers
                                onEdit={() => {
                                    setIsEditMode(true)
                                }}
                                onDeleteSuccess={() => {
                                    setIsSelectorOpen(false)
                                    setIsLoading(true)
                                }}
                            />
                        )}
                </>
            )}
        </MarchPromoContainer>
    )
}
export default MarchPromoInfo
